import React from 'react';
import PropTypes from 'prop-types';

import ArrowRightIcon from '@icons/ArrowRightIcon';
import { BodyLarge, DivWithShadowAlternate, H4, LinkSmall } from '@styled';
import colors from '@general/colors';
// import Tabs from '@molecules/Tabs';

import SearchEventExhibitorsAll from '../../searches/SearchEventExhibitorsAll';
import useEvent from '../../../hooks/useEvent';
// import SearchEventExhibitorsSaved from '../../searches/SearchEventExhibitorsSaved';

const EventExhibitors = ({ eventCode }) => {
    const event = useEvent(eventCode);

    if (!event) {
        return null;
    }

    const hasMysId = event?.map_your_show_id !== null;

    return (
        <div>
            <H4 className="mb-1.25rem">Connect With Exhibitors</H4>

            <div>
                <div>
                    <div className="align-items-start d-block d-md-flex justify-content-between mb-2rem">
                        <BodyLarge className="pr-1.75rem">Exhibitors that are attending this event.</BodyLarge>

                        <div className="d-block d-md-flex pt-0.25rem">
                            {hasMysId && (
                                <LinkSmall
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={`https://${event.map_your_show_id}.mapyourshow.com/8_0/explore/exhibitor-alphalist.cfm#/`}
                                    className="align-items-center cursor-pointer d-flex text-primary whitespace-nowrap"
                                >
                                    <span className="mr-0.5rem">See All Exhibitors and Floor Plans</span>
                                    <ArrowRightIcon color={colors.primary} />
                                </LinkSmall>
                            )}
                        </div>
                    </div>

                    <DivWithShadowAlternate style={{ minHeight: 'calc(2rem + 30vh)' }} className="p-4 mb-1rem">
                        <SearchEventExhibitorsAll eventCode={eventCode} />
                    </DivWithShadowAlternate>
                </div>
                {/* Per Sang: Hide Saved Exhibitors tab for now.
                    TODO: When Saved Exhibitors is added, uncomment it,
                    and add the Tabs Component (see commit history)

                <div tabKey="saved" title="Saved Exhibitors">
                    <SearchEventExhibitorsSaved
                        additionalFilters={`events:${eventCode}`}
                        displayPagingToolbar
                        hitsPerPage={6}
                        parentView="Events"
                        resultsPerRow={3}
                        showPagingToolbar
                        NoResultsText={() => <>Looks like none of your saved exhibitors are attending this event.</>}
                    />
                </div> */}
            </div>
        </div>
    );
};

EventExhibitors.propTypes = {
    eventCode: PropTypes.string.isRequired,
};

export default EventExhibitors;
